import { Component, createElement } from 'react';
import { Field } from 'react-final-form';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      

var ExternallyChangedState = function (_React$Component) {
  inherits(ExternallyChangedState, _React$Component);

  function ExternallyChangedState(props) {
    classCallCheck(this, ExternallyChangedState);

    var _this = possibleConstructorReturn(this, (ExternallyChangedState.__proto__ || Object.getPrototypeOf(ExternallyChangedState)).call(this, props));

    _this.state = {
      previous: props.input.value,
      externallyChanged: false
    };
    return _this;
  }

  createClass(ExternallyChangedState, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          value = _props.input.value,
          active = _props.meta.active;
      var previous = this.state.previous;

      if (value !== previous) {
        this.setState({ previous: value, externallyChanged: !active });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.state.externallyChanged);
    }
  }]);
  return ExternallyChangedState;
}(Component);

var ExternallyChanged = function ExternallyChanged(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: { active: true, value: true },
    allowNull: true,
    render: function render(props) {
      return createElement(ExternallyChangedState, _extends({}, props, { children: children }));
    }
  });
};

//      

var OnBlurState = function (_React$Component) {
  inherits(OnBlurState, _React$Component);

  function OnBlurState(props) {
    classCallCheck(this, OnBlurState);

    var _this = possibleConstructorReturn(this, (OnBlurState.__proto__ || Object.getPrototypeOf(OnBlurState)).call(this, props));

    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  createClass(OnBlurState, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          children = _props.children,
          active = _props.meta.active;
      var previous = this.state.previous;

      if (previous && !active) {
        children();
      }
      if (previous !== active) {
        this.setState({ previous: active });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return OnBlurState;
}(Component);

var OnBlur = function OnBlur(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: { active: true },
    render: function render(props) {
      return createElement(OnBlurState, _extends({}, props, { children: children }));
    }
  });
};

//      

var OnChangeState = function (_React$Component) {
  inherits(OnChangeState, _React$Component);

  function OnChangeState(props) {
    classCallCheck(this, OnChangeState);

    var _this = possibleConstructorReturn(this, (OnChangeState.__proto__ || Object.getPrototypeOf(OnChangeState)).call(this, props));

    _this.state = {
      previous: props.input.value
    };
    return _this;
  }

  createClass(OnChangeState, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          children = _props.children,
          value = _props.input.value;
      var previous = this.state.previous;

      if (value !== previous) {
        this.setState({ previous: value });
        children(value, previous);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return OnChangeState;
}(Component);

var OnChange = function OnChange(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: { value: true },
    allowNull: true,
    render: function render(props) {
      return createElement(OnChangeState, _extends({}, props, { children: children }));
    }
  });
};

//      

var OnFocusState = function (_React$Component) {
  inherits(OnFocusState, _React$Component);

  function OnFocusState(props) {
    classCallCheck(this, OnFocusState);

    var _this = possibleConstructorReturn(this, (OnFocusState.__proto__ || Object.getPrototypeOf(OnFocusState)).call(this, props));

    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  createClass(OnFocusState, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          children = _props.children,
          active = _props.meta.active;
      var previous = this.state.previous;

      if (active && !previous) {
        this.setState({ previous: active });
        children();
      } else if (!active && previous) {
        this.setState({ previous: active });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return OnFocusState;
}(Component);

var OnFocus = function OnFocus(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: { active: true },
    render: function render(props) {
      return createElement(OnFocusState, _extends({}, props, { children: children }));
    }
  });
};

//

export { ExternallyChanged, OnBlur, OnChange, OnFocus };
